import React from "react"
import { Flex, Heading, Tag, Text } from "@chakra-ui/react"
export default function PostBody({ title, tag, date, description }) {
  return (
    <Flex
      direction="column"
      w={{ base: "full", md: 2 / 3, lg: "full", xl: 2 / 3 }}
      p={6}
    >
      <Flex justify="space-between" w="full" align="center">
        <Heading fontSize="lg" fontWeight="medium" alignSelf="flex-start">
          {title}
        </Heading>
        <Flex>
          <Tag as={Flex} size="sm" variant="outline" colorScheme="primary">
            {tag}
          </Tag>
        </Flex>
      </Flex>
      <Text size="xs" fontWeight="light">
        {date}
      </Text>
      <Text mt={4}>{description}</Text>
    </Flex>
  )
}
